import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ITemplate } from '@dxp/core/models';
import { map, Observable } from 'rxjs';
import { MediaGroup, LOGGER_REQUEST_NAME } from '@dxp/core/types';
import { environment } from '@dxp/core/environment';

@Injectable({
    providedIn: 'root',
})
export class TemplateApiService {
    readonly #http = inject(HttpClient);

    getTemplates(
        mediaGroup: MediaGroup,
        businessUnitId?: string | null,
    ): Observable<ITemplate[]> {
        return this.#http
            .get<ITemplate[]>(
                `${environment.templatesUrl}?mediaGroup=${mediaGroup}`,
                {
                    context: new HttpContext().set(
                        LOGGER_REQUEST_NAME,
                        'Template Service (Get Templates)',
                    ),
                },
            )
            .pipe(
                map(templates =>
                    templates
                        .filter(t =>
                            businessUnitId === undefined
                                ? true
                                : t.businessUnitId === businessUnitId,
                        )
                        .sort((a, b) => a.name.localeCompare(b.name)),
                ),
            );
    }

    getTemplateContent(
        templateId: string,
        conversationId: string,
        customerId: string,
        agentId: string,
        mediaGroup: MediaGroup,
    ): Observable<string> {
        const params = new HttpParams()
            .set('conversationId', conversationId)
            .set('customerId', customerId)
            .set('agentId', agentId)
            .set('mediaGroup', mediaGroup);

        return this.#http
            .get<{
                htmlContent: string;
            }>(`${environment.templatesUrl}/${templateId}/personalized`, {
                params,
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Template Service (Get Template Content)',
                ),
            })
            .pipe(map(response => response.htmlContent));
    }
}
